enum EWorkerType {
  Accountant = 'accountant',
  Admin = 'admin',
  Technician = 'technician',
}

export default EWorkerType;
